import { render, staticRenderFns } from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=template&id=0a3f49d6&scoped=true"
import script from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=script&lang=js"
export * from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=style&index=0&id=0a3f49d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f49d6",
  null
  
)

export default component.exports